import styled from "styled-components";
import { Button } from "@pepdirect/v3/ui/Button";
import { colors } from "@pepdirect/v3/styles/variables";
import { Device } from "@pepdirect/v3/styles/screenSizes";

/**
 * NOTE: This file is shared with BraintreeReviewStep
 */

export const StyledReviewSection = styled.div`
  font-size: 13px;
`;

export const StyledSubmitButtonWrapper = styled.div`
  @media ${Device.mobile} {
    bottom: 0;
    left: 0;
    position: fixed;
    width: 100%;
    z-index: 100000;
    box-shadow: 0 3px 10px 2px rgb(0 0 0 / 20%);
    padding: 16px;
    background-color: ${colors.white};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
`;

export const StyledAgreeToTermsText = styled.div`
  @media ${Device.notMobile} {
    display: none;
  }
`;

export const StyledButton = styled(Button)`
  @media ${Device.mobile} {
    width: 100%;
  }
`;
